<template>
  <div id="app">
    <el-header>
      <LeftNavBar v-if="hamburguerMenu && sesion.resultadoAutenticacion" />
      <img class='logo' src='@/images/colven-blanco.png' @click="$router.push({ name: 'Home' })" />
      
      <el-dropdown class="perfilDropdown" trigger="click" v-if="sesion.resultadoAutenticacion !== undefined && sesion.resultadoAutenticacion.EstaAutenticado === true">
        <span class="el-dropdown-link">
          <i class="el-icon-user"></i>
          <span class="username">{{ username }}</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <router-link :to="{ name: 'Perfil'}">
            <el-dropdown-item @click.native="showCambioContrasenia">{{$t('PERFIL_perfil')}}</el-dropdown-item>
          </router-link>
          <el-dropdown-item v-if="SID == null" @click.native="showCambioContrasenia = true">{{$t('CHANGE_PASS_changePassword')}}</el-dropdown-item>
          <router-link :to="{ name: 'TwoFactorAuthentication'}">
            <el-dropdown-item>{{$t('TWO_FACTOR_AUTHENTICATION_twoFactorAuthentication')}}</el-dropdown-item>
          </router-link>
          <el-dropdown-item divided @click.native="onCerrarSesion">{{$t('GENERAL_salir')}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      
      <el-dropdown class="perfilDropdown" trigger="click" @command="changeLocale">
        <span class="el-dropdown-link">
          {{ currentLocal }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="lang in languages" :key="lang.title" :command="lang.language">{{ lang.title }}</el-dropdown-item>          
        </el-dropdown-menu>
      </el-dropdown>
    </el-header>

    <transition name="fade" mode="out-in">
      <router-view />
    </transition>

    <!-- modal de cambio de contraseña -->
    <CambioContrasenia 
      :show="showCambioContrasenia" 
      :onClose="() => { showCambioContrasenia = false }"
    />
  </div>
</template>

<script>
import CambioContrasenia from './components/Login/cambioContrasenia'
import LeftNavBar from '@/components/Main/LeftNavBar'
import { mapState } from 'vuex'
import i18n from '@/plugins/i18n'
import 'element-ui/lib/theme-chalk/display.css';
import { tienePermiso } from './security/autorizador'
import { targets } from './security/target'

export default {
  name: 'app',
  components: { LeftNavBar, CambioContrasenia },
  data() {
    return {
      languages: [
        { language: 'en', title: 'English' },
        { language: 'es', title: 'Español' }
      ],
      hamburguerMenu: false,
      showCambioContrasenia: false
    }
  },
  computed: {
    currentLocal: function(){
      switch (i18n.locale) {
        case 'es':
          return 'Español'
        case 'en':
          return 'English'
      }
    },
    username() {
      return this.sesion.resultadoAutenticacion ? this.sesion.resultadoAutenticacion.Usuario : ''
    },
    SID(){
      return this.sesion.resultadoAutenticacion ? this.sesion.resultadoAutenticacion.SID : null
    },
    ...mapState({
      sesion: state => state.sesion
    }),
  },
  methods: {
    changeLocale(locale) {
      i18n.locale = locale;
    },

    onCerrarSesion() {
      this.$store.dispatch('sesion/cerrarSesion').then(() => this.$router.push({ name: 'Login' }))
    },

    onResize() {
      if(window.innerWidth < 600)
          this.hamburguerMenu = true
      else
          this.hamburguerMenu = false
    }
  },
  created() 
  {
    // busco los mensajes internacionalizados
    this.$store.dispatch('app/getMensajesInternacionalizados')
    
  },
  mounted() 
  {
    // Register an event listener when the Vue component is ready
    window.addEventListener('resize', this.onResize)
    this.onResize()
  },
  beforeDestroy() 
  {
    // Unregister the event listener before destroying this Vue instance
    window.removeEventListener('resize', this.onResize)
  }
}

import ('normalize.css')

</script>

<style>
:root {
  --main-color: #009FDF;
}
html {
  font-family: Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: white;
  min-height: 100vh;
}
a {
  color: transparent;
}
.el-main {
  margin-top: 40px;
  margin-left: 65px;
}
.el-dialog{
  border-radius: 8px !important;
  border-top: 8px solid var(--main-color);
  text-align: left;
}
.el-dialog__title{
  font-size: 22px !important;
  font-weight: bold !important;
  text-align: left !important;
  color: var(--main-color) !important;
  margin-bottom: 20px !important;
  text-align: left !important;
}

.el-dialog__body{
  border-top: 1px solid #ececec;
  border-bottom: 1px solid #ececec;
  margin-left: 10px;
  margin-right: 10px;
}
@media (min-width: 801px) {
  .el-main {
    margin-left: 300px;
    padding: 20px 0 !important;
  }
  
}
@media (max-width: 600px) {
  .el-main {
    margin-left: 0px;
    padding: 10px 10px !important;
  }
  .el-dialog{
    min-width: 90% !important;
  }
}

.el-aside {
  position: fixed;
  top: 40px;
  width: inherit !important;
}
.el-collapse-item__header{
  font-weight: bold !important;
  font-size: 14px !important;
}
/* colores*/

.primary {
  color: var(--main-color) !important;
}
.el-button {
  padding: 12px 40px !important;
}
.el-button.is-circle {
  border-radius: 50% !important;
  padding: 12px !important;
}
.el-button.is-round{
  border-radius: 5px !important;
  padding: 5px 5px !important;
}

.el-button--primary {
  border-radius: 0 !important;
}
.el-button--primary {
  background-color: var(--main-color) !important;
}
.el-link--primary {
  color: #5AABC6 !important;
}
.el-button--primary.is-disabled,
.el-button--primary.is-disabled:hover {
    background-color: #a0cfff !important;
    cursor: default !important;
}

/* /colores */

.el-card {
  border-top: 4px solid var(--main-color) !important;
  width: 100% !important;
}

.el-menu {
  border-right: none !important;
  background-color: #fdfdfd !important;
}

.el-menu-item {
  text-align: left;
  background-color: #fdfdfd !important;
  font-size: 16px !important;
  color: #6B6B6B !important;
}

.el-menu-item.is-active {
  border-left: 4px solid var(--main-color) !important;
  color: var(--main-color) !important;
  background-color: white !important;
}

.el-menu-item:focus, .el-menu-item:hover {
  background-color: white !important;
}

.el-menu-item, .el-submenu__title {
  height: 33px !important;
  line-height: 33px !important;
}

.el-menu-item [class^=el-icon-] {
  margin-top: -4px;
}

.el-menu-item.is-active [class^=el-icon-] {
  font-weight: bold;
}

.el-table th>.cell {
  color: #595959;
}

.el-table tr {
  cursor: pointer;
}
.el-table .table-header > th{
  background-color: var(--main-color) !important;
  color: white !important;
  font-weight: bold;
  text-align: left;
  padding-top: 0px; 
  padding-bottom: 0px;
}

.el-dropdown.perfilDropdown {
  float: right;
  z-index: 5;
  top: 12px;
  padding: 0 20px;
}
.el-dropdown-link {
  cursor: pointer;
  color: white;
}
.el-dropdown-menu__item {
  text-align: left;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.el-header {
  background-color: var(--main-color);
  border-bottom: 1px solid #E2E2E2;
  height: 60px !important;
  align-items: center;
  padding: 10px 10px !important;
  position: fixed;
  width: 100%;
  z-index: 5;
}

img.logo {
  height: 90%;
  max-height: 40px;
  margin-top: 0.15%;
  vertical-align: middle;
  float: left;
  cursor: pointer;
}

@media (max-width: 600px) {
  img.logo {
    height: 20px;
    margin-top: 10px;
  }

  .el-dropdown.perfilDropdown
  {
    display: block;
    top: 5px;
  }
}

a:-webkit-any-link {
  text-decoration: none;
}

.el-radio__label {
  font-size: 14px !important;
  /* padding-left: 10px !important; */
  color: #A0A0A0;
  font-weight: 600 !important;
}

.fade-enter-active {
  transition: opacity 0.1s ease;
}

.fade-leave-active {
  transition: opacity 0.1s ease;
  opacity: 0;
}

.el-select-dropdown { 
  text-align: left;
}

.username {
  margin-left: 5px;
}

</style>
